/* eslint-disable tree-shaking/no-side-effects-in-initialization -- plugin doesn't handle JSX node */
import React from "react";

import { createCustomIcon } from "./createCustomIcon";

/** See https://www.notion.so/hexhq/How-to-Adding-a-new-Custom-Icon-914117a2642148e09b257605075dcfc0 for guidance */

export const CornerAccent = createCustomIcon({
  name: "cornerAccent",
  category: "Plans",
  path: (
    <>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          d="M0.5 0.5L13 0.5L13 1.5L1.5 1.5L1.5 13L0.500001 13L0.5 0.5Z"
          fill="CurrentColor"
          fillRule="evenodd"
        />
      </svg>
    </>
  ),
});

export const EnterpriseTierIcon = createCustomIcon({
  name: "enterpriseTier",
  size: "extra-large",
  category: "Plans",

  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.166 21C19.032 21 22.166 17.866 22.166 14C22.166 10.134 19.032 7 15.166 7C11.3 7 8.16602 10.134 8.16602 14C8.16602 17.866 11.3 21 15.166 21ZM15.166 22C19.5843 22 23.166 18.4183 23.166 14C23.166 9.58172 19.5843 6 15.166 6C10.7477 6 7.16602 9.58172 7.16602 14C7.16602 18.4183 10.7477 22 15.166 22Z"
        fill="currentColor"
      />
      <circle cx="15.166" cy="14" r="2" fill="currentColor" fillOpacity="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33301 1.5H27.333V26.5H2.33301V1.5ZM3.33301 2.5V25.5H26.333V2.5H3.33301Z"
        fill="currentColor"
      />
    </>
  ),
});

export const TeamTierIcon = createCustomIcon({
  name: "teamTier",
  size: "extra-large",
  category: "Plans",

  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 21.5C18.366 21.5 21.5 18.366 21.5 14.5C21.5 10.634 18.366 7.5 14.5 7.5C10.634 7.5 7.5 10.634 7.5 14.5C7.5 18.366 10.634 21.5 14.5 21.5ZM14.5 22.5C18.9183 22.5 22.5 18.9183 22.5 14.5C22.5 10.0817 18.9183 6.5 14.5 6.5C10.0817 6.5 6.5 10.0817 6.5 14.5C6.5 18.9183 10.0817 22.5 14.5 22.5Z"
        fill="currentColor"
      />
      <circle cx="14.5" cy="14.5" r="2" fill="currentColor" fillOpacity="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H8.5V3H3V8.5H2V2ZM20.5 2H27V8.5H26V3H20.5V2ZM2 20.5H3V26H8.5V27H2V20.5ZM27 20.5V27H20.5V26H26V20.5H27Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CommunityTierIcon = createCustomIcon({
  name: "communityTier",
  size: "extra-large",
  category: "Plans",

  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9635 14.9424L24.9665 14.865C24.9887 14.5798 25 14.2913 25 14C25 13.7087 24.9887 13.4202 24.9665 13.135L25.9635 13.0576C25.9877 13.3685 26 13.6828 26 14C26 14.3172 25.9877 14.6315 25.9635 14.9424ZM25.671 11.1974L24.6984 11.4301C24.5632 10.8651 24.3844 10.317 24.1657 9.7896L25.0894 9.40655C25.3282 9.98227 25.5234 10.5806 25.671 11.1974ZM24.2332 7.72928L23.3811 8.25258C23.0788 7.76033 22.7388 7.29356 22.365 6.85633L23.1251 6.20653C23.5326 6.68326 23.9035 7.1923 24.2332 7.72928ZM21.7935 4.87491L21.1437 5.63501C20.7064 5.26123 20.2397 4.92121 19.7474 4.61892L20.2707 3.76677C20.8077 4.09653 21.3167 4.46736 21.7935 4.87491ZM18.5935 2.91057L18.2104 3.83429C17.683 3.61558 17.1349 3.43677 16.5699 3.30158L16.8026 2.32903C17.4194 2.47661 18.0177 2.67182 18.5935 2.91057ZM14.9424 2.03646L14.865 3.03346C14.5798 3.0113 14.2913 3 14 3C13.7087 3 13.4202 3.0113 13.135 3.03346L13.0576 2.03646C13.3685 2.01231 13.6828 2 14 2C14.3172 2 14.6315 2.0123 14.9424 2.03646ZM11.1974 2.32903L11.4301 3.30158C10.8651 3.43677 10.317 3.61558 9.7896 3.83429L9.40655 2.91057C9.98227 2.67182 10.5806 2.47661 11.1974 2.32903ZM7.72928 3.76677C7.1923 4.09653 6.68326 4.46736 6.20653 4.87491L6.85633 5.63501C7.29356 5.26124 7.76033 4.92121 8.25258 4.61892L7.72928 3.76677ZM4.87491 6.20654L5.63501 6.85634C5.26123 7.29356 4.92121 7.76033 4.61892 8.25258L3.76677 7.72929C4.09653 7.1923 4.46736 6.68326 4.87491 6.20654ZM2.91057 9.40655L3.83429 9.7896C3.61558 10.317 3.43677 10.8651 3.30158 11.4301L2.32903 11.1974C2.47661 10.5806 2.67182 9.98227 2.91057 9.40655ZM2.03646 13.0576C2.0123 13.3685 2 13.6828 2 14C2 14.3172 2.01231 14.6315 2.03646 14.9424L3.03346 14.865C3.0113 14.5798 3 14.2913 3 14C3 13.7087 3.0113 13.4202 3.03346 13.135L2.03646 13.0576ZM2.32903 16.8026L3.30158 16.5699C3.43677 17.1349 3.61558 17.683 3.83429 18.2104L2.91057 18.5935C2.67182 18.0177 2.47661 17.4194 2.32903 16.8026ZM3.76677 20.2707L4.61892 19.7474C4.92121 20.2397 5.26124 20.7064 5.63501 21.1437L4.87491 21.7935C4.46736 21.3167 4.09653 20.8077 3.76677 20.2707ZM6.20654 23.1251L6.85634 22.365C7.29356 22.7388 7.76033 23.0788 8.25258 23.3811L7.72929 24.2332C7.1923 23.9035 6.68326 23.5326 6.20654 23.1251ZM9.40655 25.0894L9.7896 24.1657C10.317 24.3844 10.8651 24.5632 11.4301 24.6984L11.1974 25.671C10.5806 25.5234 9.98227 25.3282 9.40655 25.0894ZM13.0576 25.9635L13.135 24.9665C13.4202 24.9887 13.7087 25 14 25C14.2913 25 14.5798 24.9887 14.865 24.9665L14.9424 25.9635C14.6315 25.9877 14.3172 26 14 26C13.6828 26 13.3685 25.9877 13.0576 25.9635ZM16.8026 25.671L16.5699 24.6984C17.1349 24.5632 17.683 24.3844 18.2104 24.1657L18.5935 25.0894C18.0177 25.3282 17.4194 25.5234 16.8026 25.671ZM20.2707 24.2332L19.7474 23.3811C20.2397 23.0788 20.7064 22.7388 21.1437 22.365L21.7935 23.1251C21.3167 23.5326 20.8077 23.9035 20.2707 24.2332ZM23.1251 21.7935L22.365 21.1437C22.7388 20.7064 23.0788 20.2397 23.3811 19.7474L24.2332 20.2707C23.9035 20.8077 23.5326 21.3167 23.1251 21.7935ZM25.0894 18.5935L24.1657 18.2104C24.3844 17.683 24.5632 17.1349 24.6984 16.5699L25.671 16.8026C25.5234 17.4194 25.3282 18.0177 25.0894 18.5935Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <circle cx="14" cy="14" r="2" fill="currentColor" fillOpacity="0.5" />
    </>
  ),
});

export const ProfessionalTierIcon = createCustomIcon({
  name: "professionalTier",
  size: "extra-large",
  category: "Plans",

  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 25C20.0751 25 25 20.0751 25 14C25 7.92487 20.0751 3 14 3C7.92487 3 3 7.92487 3 14C3 20.0751 7.92487 25 14 25ZM14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26Z"
        fill="currentColor"
      />
      <circle cx="14" cy="14" r="2" fill="currentColor" fillOpacity="0.5" />
    </>
  ),
});

export const PlanResourcesIcon = createCustomIcon({
  name: "planResources",
  size: "extra-large",
  category: "Plans",

  path: (
    <>
      <path
        d="M13 2V13H2V2H13ZM3 12H12V3H3V12Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <path
        d="M13 15V26H2V15H13ZM3 25H12V16H3V25Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <path d="M26 2V13H15V2H26ZM16 12H25V3H16V12Z" fill="currentColor" />
      <path
        d="M26 15V26H15V15H26ZM16 25H25V16H16V25Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
    </>
  ),
});
